import {html} from 'lit-html';
import {classMap} from 'lit-html/directives/class-map';
import {styleMap} from 'lit-html/directives/style-map';

import TemplateRegistry from '../template/template-registry';
import SavedConfigs from '../config/saved-configs';

export const icons = {
    bookmark: html`<svg class="cl-po--icon cl-po--save-config-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" aria-hidden="true"><path d="M4 2h12v17l-6-4-6 4V2zm2 2v11.3l4-2.7 4 2.7V4H6z"></path></svg>`,
    heart: html`<svg class="cl-po--icon cl-po--save-config-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" aria-hidden="true"><path d="M10 18.3l-1.2-1.1C4.4 13.3 1.5 10.7 1.5 7.4 1.5 4.8 3.6 2.7 6.2 2.7c1.5 0 2.9.7 3.8 1.8.9-1.1 2.3-1.8 3.8-1.8 2.6 0 4.7 2.1 4.7 4.7 0 3.3-2.9 5.9-7.3 9.8L10 18.3z"></path></svg>`,
    email: html`<svg class="cl-po--icon cl-po--save-config-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" aria-hidden="true"><path d="M2 4h16v12H2V4zm2 2.4V14h12V6.4l-6 4.2-6-4.2zM5.2 6L10 9.4 14.8 6H5.2z"></path></svg>`
};

const spinner = html`<svg class="cl-po--icon loading" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" aria-hidden="true"><path d="M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0v2c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8h2z"></path></svg>`;

// the theme classes of params.classList replace the app button look, a set color adds its class ( !important rule ) either way
// editorMode keeps the app look: the admin preview has no theme CSS
export const buttonClassMap = (params, editorMode) => {
    const themeClasses = !editorMode && typeof params.classList === 'string' ? params.classList.split(' ').filter(Boolean) : [];
    const map = {
        'cl-po--swatch': !themeClasses.length,
        'cl-po--swatch-button': !themeClasses.length,
        'cl-po--save-config-color': !!params.btnColor,
        'cl-po--save-config-bg': !!params.btnBgColor
    };

    themeClasses.forEach((name) => map[name] = true);

    return map;
};

// set colors as variables on the button
const colorStyleMap = (params) => {
    const map = {};
    if (params.btnColor) map['--cl-po-save-config-color'] = params.btnColor;
    if (params.btnBgColor) map['--cl-po-save-config-bg'] = params.btnBgColor;
    return map;
};

/**
 * Save Config - "Save for later" button of the current configuration (no value of its own)
 * UI only: snapshot, requests and the dialogs live in config/saved-configs.js (config.configs)
 * A save always creates a new configuration - while it runs the button spins ( same spinner as the cart block )
 * After a save a status below the button tells where to find it: the account, or the typed email of a guest save
 * The button is full width, custom CSS targets .cl-po--save-config-button
 * params: btnText, btnColor, btnBgColor, btnIcon (bookmark | heart | email), classList (theme classes, replace the app button look)
 */
TemplateRegistry.templates['save-config'] = (option, config) => {
    const configs = config.configs;
    const params = option.params;

    // no app embed marker or hidden for the visit > the option hides itself, label included
    if (!configs || !configs.shown()) return html`<style>[data-option="${option.name}"] { display:none; }</style>`;

    return html`
        <div class="cl-po--save-config ${classMap({ 'cl-po--loading': configs.saving })}">
            <button type="button" class="cl-po--save-config-button ${classMap(buttonClassMap(params, config.editorMode))}" style=${styleMap(colorStyleMap(params))} ?disabled=${configs.saving} aria-busy="${configs.saving ? 'true' : 'false'}"
                    @click=${() => configs.promptSave()}>
                ${icons[params.btnIcon] || null}<span class="cl-po--save-config-text">${params.btnText || SavedConfigs.t('save')}</span>${configs.saving ? spinner : null}
            </button>

            ${configs.saved ? html`<p class="cl-po--save-config-saved" role="status" aria-live="polite">${configs.savedNotice()}</p>` : null}
        </div>
    `;
};
